import React from 'react';

import { DirectLink } from '@src/core/buyerApiClient';

import CartSummary from './CartSummary';
import OrderSummary from './OrderSummary';
import PaymentSummary from './PaymentSummary';
import SaleSummary from './SaleSummary';

interface SummaryProps {
  directLink: DirectLink;
  showTotal?: boolean;
}

export const Summary = (props: SummaryProps) => {
  const { directLink, showTotal = false } = props;

  const renderSummary = {
    cart: <CartSummary showTotal={showTotal} />,
    sale: <SaleSummary showTotal={showTotal} />,
    order: <OrderSummary showTotal={showTotal} />,
    payment: <PaymentSummary directLink={directLink} showTotal={showTotal} />,
  }[directLink.type];

  return <>{renderSummary}</>;
};

export default Summary;
